module.exports = __webpack_public_path__ + "img/flower_leaf_14.5909f958.png";